import { on } from "delegated-events";
import Swiper from "swiper";
import { A11y, Autoplay, EffectFade } from "swiper/modules";

const setupPageHeaderSlider = () => {
  const pageHeaderSlider = document.querySelector(".international-page-header .header-media-slider");

  if (!pageHeaderSlider) {
    return;
  }

  const swiper = new Swiper(pageHeaderSlider.querySelector(".swiper"), {
    modules: [A11y, Autoplay, EffectFade],
    autoplay: {
      delay: 4000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
  });

  on("click", ".international-page-header .media-slider-control", (e) => {
    const button = e.currentTarget;

    if (button.dataset.state === "playing") {
      button.setAttribute("data-state", "paused");
      swiper.autoplay.pause();
    } else {
      button.setAttribute("data-state", "playing");
      swiper.autoplay.resume();
    }
  });
};

setupPageHeaderSlider();
